import { router } from "../../../App";
import { fetchWrapper } from "../../../utils/fetch";
import { globalState } from "../../global-state";
import { enumPasso } from "../../simulacao";
import { gotoPassoContratacao } from "./passo-contracao";

export interface IPassoSeguroState {
    nome?: string
    nomeSocial?: string
    cpf?: string
    codPlano?: string

    planos?: {
        codPlano: string
        nome: string
        vlrPremio: number
    }[]
    coberturas?: {
        nome: string
        valores: {
            codPlano: string
            valor: number
        }[],
        helperText: string
    }[]
}

const getPassoSeguro = () =>
    fetchWrapper<IPassoSeguroState>("/api/seguro")

const postPassoSeguro = (toSave: IPassoSeguroState) =>
    fetchWrapper<{ seguradoraImageBase64: string }>("/api/seguro", {
        method: "POST",
        body: JSON.stringify({
            nome: toSave.nome,
            nomeSocial: toSave.nomeSocial,
            codPlano: toSave.codPlano
        }),
        headers: {
            'Content-type': 'application/json; charset=UTF-8'
        }
    })

export const savePassoSeguro = async (toSave: IPassoSeguroState) => {
    globalState.isLoading.set(true);

    const response = await postPassoSeguro(toSave);

    if (response) {
        globalState.passoSeguro.merge({
            nome: toSave.nome,
            nomeSocial: toSave.nomeSocial,
            codPlano: toSave.codPlano
        });
        const plano = globalState.passoSeguro.planos.find(p => p.codPlano.get() === toSave.codPlano).get();
        
        globalState.simulacao.summaryBox.merge({
            nome: toSave.nome,
            plano: plano.nome,
            vlrPremio: plano.vlrPremio,
            seguradoraImageBase64: response.seguradoraImageBase64
        });

        globalState.simulacao.passoAlcancado.set(enumPasso.contratacao);

        await gotoPassoContratacao();
    }

    globalState.isLoading.set(false);
}

let passoSeguro = null;

export const gotoPassoSeguro = async () => {
    if (!passoSeguro) {
        globalState.isLoading.set(true);

        passoSeguro = await getPassoSeguro();

        if (passoSeguro) {
            globalState.passoSeguro.set(passoSeguro);
            await router.navigate("/seguro", { replace: true });
        }
    }

    if (passoSeguro) 
        globalState.simulacao.passo.set(enumPasso.seguro);
        
    globalState.isLoading.set(false);
}